<template>
  <div class="props-group">
      <el-form-item label="关联工号">
        <el-checkbox v-model="loginUser.jobNum"></el-checkbox>
      </el-form-item>
      <el-form-item label="关联部门">
        <el-checkbox v-model="loginUser.department"></el-checkbox>
      </el-form-item>
      <el-form-item label="关联岗位">
        <el-checkbox v-model="loginUser.post"></el-checkbox>
      </el-form-item>
  </div>
</template>

<script>
import { UUID } from '@/plugins/common'
import {getProperties} from '@/store/form/componentDefaults.js'

export default {
  name: 'attr-relevance',
  props: [ 'component' ],
  inject: ['formService'],
  data () {
    return {
      loginUser: {
        jobNum: false,
        department: false,
        post: false
      }
    }
  },
  mounted () {
    for (let attr in this.loginUser) {
      this.loginUser[attr] = this.component.properties.loginUser[attr] !== ''
    }
  },
  methods: {
    // 保存操作
    saveAttr () {
      let addComponent = []
      let removerComponent = []

      for (let attr in this.loginUser) {
        if (this.loginUser[attr]) {
          // 如果勾中选项
          if (this.component.properties.loginUser[attr] === '') {
            // 该属性不存在对应子控件, 记录下来, 用于增加子控件
            addComponent.push(attr)
          }
        } else {
          // 如果取消选项
          if (this.component.properties.loginUser[attr] !== '') {
            // 该控件之前存在对应子控件, 记录下来, 用于删除子控件
            removerComponent.push(this.component.properties.loginUser[attr])
            this.component.properties.loginUser[attr] = ''
          }
        }
      }
      let parentComponent = this.formService.getParentComponent(this.component)

      addComponent.forEach(async (m, index) => {
        let component = childrenComponent[m]
        let name = component.defaults.name
        component = getProperties('rc-children-input')
        component.defaults.id = UUID.create()
        component.defaults.name = name
        this.component.properties.loginUser[m] = component.defaults.id
        let pinyin = await this.formService.getPinyinByHanzi(component.defaults.name)
        component.defaults.pinyinName = pinyin.pinyinName
        component.defaults.pinyinFirstChar = pinyin.pinyinFirstChar
        let cm = this.formService.createComponent(component, parentComponent)
        this.$nextTick(() => {
          let table = this.formService.schema.getTable(cm.archive.tableId)
          // 表格不需要改列的值
          if (cm.componentType === 'rc-table') {
            table.pinyinName = pinyin.pinyinName
            table.pinyinFirstChar = pinyin.pinyinFirstChar
          } else {
            if (table && table.columns) {
              let c = table.columns.find(c => c.id === cm.archive.columnId)
              c.pinyinName = pinyin.pinyinName
              c.pinyinFirstChar = pinyin.pinyinFirstChar
            }
          }
        })
      })

      removerComponent.forEach(m => {
        let component = this.formService.getComponentById(m)
        this.formService.removeComponent(component)
      })
    }
  },
  computed: {
    parentComponent () {
      return this.formService.getParentComponent(this.component)
    }
  }
}

const childrenComponent = {
  jobNum: {
    defaults: {
      name: '工号'
    }
  },
  department: {
    defaults: {
      name: '部门'
    }
  },
  post: {
    defaults: {
      name: '岗位'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/form/componentAttr/relevance.vue